import styled, { css } from 'styled-components';

import { flexCenter } from 'styles';
import { InfoBlock } from 'components/info-block';
import { Placeholder } from 'components/placeholder';

export const RightContainer = styled.div`
  gap: 16px;
  display: flex;
  flex-direction: column;
  ${({ theme }) =>
    theme.responsive.isDesktop &&
    css`
      flex: 1;
    `}
`;

export const Container = styled.div<{ withoutPadding?: boolean }>`
  gap: 16px;
  width: 100%;
  display: flex;

  ${({ theme, withoutPadding }) => css`
    flex-direction: ${theme.responsive.isDesktop ? 'row' : 'column'};
    ${!withoutPadding &&
    css`
      padding: 16px;
    `}
  `}
`;

export const RightWrap = styled.div`
  gap: 16px;
  width: 100%;
  display: flex;
  flex-direction: ${({ theme }) =>
    theme.responsive.isMobile ? 'column' : 'row'};
  > div {
    flex: 1;
  }
`;

export const PieContainer = styled.div`
  ${flexCenter};
  gap: 16px;
  width: 100%;
  min-height: 352px;
  flex-direction: column;
`;

export const Dot = styled.div<{ bg: string }>`
  width: 12px;
  height: 12px;
  min-width: 12px;
  margin-right: 4px;
  border-radius: 50%;
  background: ${(p) => p.bg};
`;

export const DatePickerContainer = styled.div<{
  datePickerContainerPadding?: string;
}>`
  ${({ theme, datePickerContainerPadding }) => css`
    padding: ${datePickerContainerPadding ?? '16px 16px 0'};
    max-width: ${theme.responsive.isMobile ? 'unset' : 'fit-content'};
  `};

  /* Room for a full "MM/DD/YYYY - MM/DD/YYYY" value plus the calendar icon
     (the input's own width cut the last digits off). */
  input {
    min-width: 240px;
  }
`;

// Full width up front: the column it sits in wraps, so without a set width
// its height is measured at one tile per row and leaves empty space below.
export const SalesOverviewBlock = styled(InfoBlock)`
  width: 100%;
`;

// Sales Overview tiles: as many per row as fit at 224px or wider, so every
// label ("Event Total Sales", "Processing Fees") shows in full on one line in
// any container (report dialog, product dashboard, location drawer). Tiles in
// a row share one height; edges and spacing match the old 16px grid gutter.
export const SalesOverviewGrid = styled.div`
  display: grid;
  column-gap: 16px;
  grid-template-columns: repeat(auto-fill, minmax(224px, 1fr));

  > * {
    min-width: 0;
    margin-bottom: 24px;
  }
`;

export const ListsContainer = styled.div`
  gap: 16px;
  display: flex;
  padding: 0 16px 16px;
  flex-direction: column;
`;

// Below the Missing sales tile (no register sales): its own height, so the
// 256px illustration never rides up over the tile on a short phone screen.
export const RegisterPlaceholder = styled(Placeholder)`
  height: auto;
  padding: 16px 0;
`;
